import React, {Component} from 'react';
import { Map, GoogleApiWrapper } from 'google-maps-react';
import {Button} from 'primereact/button';
import LocalizacaoService from '../service/LocalizacaoService';
import { Redirect } from 'react-router';
import { config } from '../Constants'

const locationBR = {lat:"-15.7997654", lng:"-47.8644715"};

const mapStyles = {
    width: '100%',
    height: '100%',
  };
const alfinete_in = config.url.CONTEXT + "assets/layout/images/alfinete-mapa-png-azul_small_p.png";
const alfinete_out = config.url.CONTEXT + "assets/layout/images/alfinete-mapa-png-azul_small_p1.png";

  export class MapContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
          //currentLocation: props.currentLocation.lat===0?locationBR:props.currentLocation,
          currentLocation: locationBR,
          //currentLocationProps: props.currentLocation.lat===0?locationBR:props.currentLocation,
          //zoom: props.currentLocation.lat===0?4:18,
          currentLocationProps: locationBR,
          zoom: 18,
          txtConfirmar: "Confirmar",
          srcAlfinete: alfinete_in,
          desabilitaBotao: false,
          montaMapa: false,
          bairro: "",
          cep: "",
          cidade: "",
          logradouro: "",
          numero: "",
          ufSigla: "",
          espaco: "",
          virgula: "",
          localizacaoAtual: false,
      };
      this.centerMoved = this.centerMoved.bind(this);
      this.onClickConfirmar = this.onClickConfirmar.bind(this);
      this.dragStart = this.dragStart.bind(this);
      this.localizacaoservice = new LocalizacaoService();
      this.showCurrentLocation = this.showCurrentLocation.bind(this);
      this.erroLocalizacao = this.erroLocalizacao.bind(this);
      this.map = React.createRef();
    }

    async showCurrentLocation() {
      if (!this.state.montaMapa){
        if (navigator.geolocation) {
          await navigator.geolocation.getCurrentPosition(
            position => {
              this.setState(prevState => ({
                currentLocationProps: {
                  ...prevState.currentLocationProps,
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                },
                zoom:18,
                montaMapa: true,
              }))
          }
          ,this.handleLocalizacao(),
          {enableHighAccuracy: true, timeout: 10000, maximumAge: 0}
          )
        }else{
            this.erroLocalizacao()
        }
      }
      return this.state.currentLocationProps;
    }
    
    erroLocalizacao(){
      this.setState = {
          currentLocation: locationBR,
          currentLocationProps: locationBR,
          zoom: 4,
      };
      console.log("Não foi possível obter a localização atual");
      alert("Não foi possível obter a localização atual");
    } 

    handleLocalizacao(){
    }
    
    centerMoved(mapProps, mapa, event) {
      this.setState({
        currentLocation: {
          lat: mapa.center.lat(0),
          lng: mapa.center.lng(0),
        },
        srcAlfinete: alfinete_in,
        bairro: "",
        cep: "",
        cidade: "",
        logradouro: "",
        numero: "",
        ufSigla: "",
        espaco: "",
        virgula: "",        
      });
      this.buscaEndereco(this.state.currentLocation);
    }

    dragStart(mapProps, mapa, event){
      this.setState({
        srcAlfinete: alfinete_out,
      });
    }

    onClickConfirmar(event){
      this.setState({
          desabilitaBotao: true,
          txtConfirmar: "Confirmando localização..",
      });

      this.localizacaoservice.postLocalizacao(this.props.id, this.state.currentLocation)
      .then(res => {
          //console.log(res);
          if (!res.hasError){
            this.setState({
                  txtConfirmar: "OK!",
                  redirect: true,
              });
          }else{
              alert("Não foi possível confirmar a localização neste momento.");
              this.setState({
                  txtConfirmar: "Confirmar",
                  desabilitaBotao: false,
              });
              console.error('Não foi possível confirmar a localização neste momento: ', res.message);
          }
      })
      .catch((err) => {
          alert("Não foi possível confirmar a localização neste momento.");
          this.setState({
              txtConfirmar: "Confirmar",
              desabilitaBotao: false,
          });
          console.error('Não foi possível confirmar a localização neste momento: ', err);
      })
    }

    buscaEndereco(loc){
      this.localizacaoservice.getEndereco(loc)
      .then(res => {
          if (!res.hasError){
            let espaco = "";
            let virgula = "";
            res.cidade&&res.ufSigla?espaco=" - ":espaco="";
            res.logradouro&&res.numero?virgula=", ":virgula="";
            this.setState({
              bairro: res.bairro,
              cep: res.cep,
              cidade: res.cidade,
              logradouro: res.logradouro,
              numero: res.numero,
              ufSigla: res.ufSigla,
              espaco: espaco,
              virgula: virgula,
            });
          };
      })
      .catch((err) => {
          console.error('Não foi possível localizar o endereço: ', err);
      })
    }

  
    async componentWillMount(){
     await this.showCurrentLocation();
    }

    async componentDidMount(){
      await this.showCurrentLocation();
     }

    render() {
      if(this.state.redirect) {
        return <Redirect to={'/localizacaoEnviada'}/>
      }
      if (!this.state.montaMapa){
        return (
          <div id="loading" className="footerHabilitaLoc"><span style={{"fontSize":"medium"}}>Carregando Localização..</span>
          <br/><br/>
          <b><span style={{"color":"#FF0000"}}>Por favor, autorize a utilização da localização.</span></b></div>
        );
      }

      return (
        <div>
          <Map 
            ref={this.map}
            google={this.props.google}
            //onDragend={this.centerMoved}
            onDragstart={this.dragStart}
            zoom={this.state.zoom}
            style={mapStyles}
            disableDefaultUI={true}
            gestureHandling={'greedy'}
            onIdle={this.centerMoved}
            initialCenter={{
              lat: this.state.currentLocationProps.lat,
              lng: this.state.currentLocationProps.lng
              }}
            />
            <div>
              <img className="alfinete" src={this.state.srcAlfinete} alt="" />
            </div>
            <div className="footer" style={{"textAlign": "center"}}>
                <div className="footerTexto">{this.state.logradouro?this.state.logradouro.replace("Avenida", "Av."):this.state.logradouro}{this.state.virgula}{this.state.numero}</div>
                <div className="footerTexto">{this.state.cidade}{this.state.espaco}{this.state.ufSigla}</div>
                <div className="footerBnt"><Button style={{"fontSize":"18px"}} label={this.state.txtConfirmar} disabled={this.state.desabilitaBotao} className="p-button-rounded botaoConfirmar" onClick={this.onClickConfirmar}/></div>
                <div className="footerTextoLoc">{this.state.currentLocation.lat}, {this.state.currentLocation.lng}</div>
            </div>
        </div>          
      );
    }
  }

  export default GoogleApiWrapper({
    client: config.dadosMap.CLIENT,
    language: config.dadosMap.LANGUAGE,
  })(MapContainer);